export const isEleicoesMunicipais = true;

export const Cargos = [
  {
    value: 'deputado estadual',
    label: 'DEPUTADO ESTADUAL',
    isEleicoesMunicipais: true,
  },
  {
    value: 'deputado federal',
    label: 'DEPUTADO FEDERAL',
    isEleicoesMunicipais: true,
  },
  {
    value: 'governador',
    label: 'GOVERNADOR',
    isEleicoesMunicipais: true,
  },
  {
    value: 'senador',
    label: 'SENADOR',
    isEleicoesMunicipais: true,
  },
  {
    value: 'vereador',
    label: 'VEREADOR',
    isEleicoesMunicipais: false,
  },
  {
    value: 'prefeito',
    label: 'PREFEITO',
    isEleicoesMunicipais: false,
  },
  {
    value: 'presidente',
    label: 'PRESIDENTE',
    isEleicoesMunicipais: true,
  },
];

export const Blocos = [
  {
    value: 1,
    label: 'BLOCO 1',
  },
  {
    value: 2,
    label: 'BLOCO 2',
  },
  {
    value: 3,
    label: 'BLOCO 3',
  },
];

export const Turnos = [
  {
    value: 'manha',
    label: 'MANHA',
  },
  {
    value: 'tarde',
    label: 'TARDE',
  },
  {
    value: 'noite',
    label: 'NOITE',
  },
];

export const Status = [
  {
    value: 'indisponivel',
    label: '●',
  },
  {
    value: 'recebido',
    label: '●',
  },
  {
    value: 'autorizado',
    label: '●',
  },
  {
    value: 'alterado',
    label: '●',
  },
  {
    value: 'recusado',
    label: '●',
  },
  {
    value: 'atrasado',
    label: '●',
  },
];
